interface ValidationInterface {
  password :{
    min :number;
    max :number;
  };
}

export const ValidationConstants :ValidationInterface = {
  password: {
    min: 8,
    max: 16,
  },
};
